<template>
    <span>{{ value | datetime }}</span>
</template>

<script>
export default {
    props: ['value'],
};
</script>



// WEBPACK FOOTER //
// DateTime.vue?f0acadf2